<template>
  <div>
    <div class="md-layout pricing-rule">
      <span>Our Hotel</span>
      <numeric-comparator
        v-model="value.action.comparison_operator"
      ></numeric-comparator>
      <span>Than</span>
      <compset-select
        multiple
        v-model="value.action.compset_ids"
        class="md-layout-item md-size-20 md-small-size-50"
      >
      </compset-select>
      <md-field class="md-layout-item md-size-10 md-small-size-50">
        <label>increments</label>
        <md-input v-model.number="value.action.delta"></md-input>
      </md-field>
      <md-radio v-model="value.action.percent" :value="false">€</md-radio>
      <md-radio v-model="value.action.percent" :value="true">%</md-radio>
    </div>
    <div class="md-layout pricing-rule">
      <board-select multiple v-model="value.board_ids"></board-select>
      <room-type-select
        multiple
        v-model="value.room_type_ids"
      ></room-type-select>
      <channel-select multiple v-model="value.channel_ids" :online="true"></channel-select>
    </div>
    <div class="md-layout pricing-rule">
      <span>When % Occ</span>
      <numeric-comparator
        v-model="
          value.condition.pricing_occupancy_condition.comparison_operator
        "
      ></numeric-comparator>
      <md-field class="md-layout-item md-size-10 md-small-size-50">
        <label>value</label>
        <md-input
          v-model.number="value.condition.pricing_occupancy_condition.delta"
        ></md-input>
      </md-field>
      <md-radio
        v-model.number="value.condition.pricing_occupancy_condition.percent"
        :value="false"
        >Rooms</md-radio
      >
      <md-radio
        v-model.number="value.condition.pricing_occupancy_condition.percent"
        :value="true"
        >%</md-radio
      >
    </div>
  </div>
</template>

<script>
import BoardSelect from "../../Inputs/BoardSelect.vue";
import ChannelSelect from "../../Inputs/ChannelSelect.vue";
import CompsetSelect from "../../Inputs/CompsetSelect.vue";
import NumericComparator from "../../Inputs/NumericComparator.vue";
import RoomTypeSelect from "../../Inputs/RoomTypeSelect.vue";

export default {
  name: "CompsetPricingRule",
  components: {
    NumericComparator,
    BoardSelect,
    RoomTypeSelect,
    ChannelSelect,
    CompsetSelect
  },
  props: {
    value: Object
  }
};
</script>
